import { AnyAction } from "redux";
import { FetchStatus, IFetchAction } from "../middleware/fetch-middleware";
import { IFacetDTO, ISearchResultDTO, ISearchResultHitDTO, ISearchRequestDTO, IAutocompleteResults, IHit, ITrackClick } from "../DTO/search";
import * as _ from 'lodash';

export enum SearchApiActions {
    GetSearchResults = 'apiSearchResultsActions/getSearchResults',
    GetAutoCompleteResults = 'apiSearchResultsActions/getAutocompleteResults',
    TrackClick = 'apiSearchResultsActions/trackClick',
}

export interface SearchApiState {
    results: ISearchResultDTO,
    autoCompleteResults: IAutocompleteResults;
}

const DefaultSearchApiState: SearchApiState = {
    results: Object.freeze({
        searchTerm: '',
        results: [] as ISearchResultHitDTO[],
        facets: [] as IFacetDTO[],
        suggestion: '',
        totalResults: 0
    } as ISearchResultDTO),

    autoCompleteResults: null
}

export const searchApiReducer = (state = DefaultSearchApiState, action: AnyAction) => {
    switch (action.type) {
        case SearchApiActions.GetSearchResults + FetchStatus.Complete:
            return { ...state, results: action.data };
        case SearchApiActions.TrackClick + FetchStatus.Complete:
            return { ...state, results: action.data };

        case SearchApiActions.GetAutoCompleteResults:
            return { ...state, autoCompleteResults: action.data ? removeAutoCompleteDuplicates(action.data) : null };

        default: return state;
    }
}

const BaseUrl = '/api/v1/search';
const AutoCompleteUrl = (window as any).bootstrap && (window as any).bootstrap.findIndexUrl + '_autocomplete';
const AutoCompleteSize = 5;

export const getSearchResults = (criteria: ISearchRequestDTO): IFetchAction => ({
    type: SearchApiActions.GetSearchResults,
    fetch: new Request(`${BaseUrl}/results`, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
        body: JSON.stringify(criteria)
    })
})

const AutocompleteBaseUrl = `${BaseUrl}/fetch/`;

export const fetchAutoCompleteResults = (searchTerm: string) => {
    return window.fetch(`${AutocompleteBaseUrl}${searchTerm}/5`, { method: 'get', headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }) })
        .then((response) => {
            return response.json()
                .then((data) => {
                    return removeAutoCompleteDuplicates(data);
                });
        })
        .catch(() => {
            return null;
        });
}

function removeAutoCompleteDuplicates(data: IAutocompleteResults) {
    var resultItems = [];
    var resultDups = [];

    for (var i = 0; i < data.hits.length; i++) {
        if (resultDups.indexOf(data.hits[i].query.trim()) === -1) {
            resultItems.push({ query: data.hits[i].query.trim() } as IHit);
            resultDups.push(data.hits[i].query.trim());
        }
    }

    data.hits = resultItems
    return data;
}
export const trackClick = (criteria: ITrackClick): IFetchAction => ({
    type: SearchApiActions.TrackClick,
    fetch: new Request(`${BaseUrl}/trackClick`, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
        body: JSON.stringify(criteria)
    })
})